export default class LoginModel {
    constructor(
        public userIdentity?: string,
        public password?: string,
		public sessionId?: string
    ) {}
}